// Shared "Home Shopping Unlocks Soon" page rendered by both
// Homes.js and HomeDetail.js when the borrower is on a pre-pricing-
// acceptance stage (HOMES_LOCKED_STATUSES). Centralized so the gate
// copy + CTA stay identical across surfaces; a borrower seeing this
// on the list page sees the same exact thing if they deep-link to a
// detail URL.
//
// Stage gating logic itself lives at each page (since the gate gets
// chained with active-offer guards differently); this component is
// just the visual.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from './AppShell';

export default function HomesLockedPage() {
  const navigate = useNavigate();
  return (
    <AppShell>
      <div style={{ textAlign: 'center', padding: '60px 20px' }}>
        <div style={{ fontSize: '40px', marginBottom: '16px' }}>🔒</div>
        <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#111827', marginBottom: '8px' }}>
          Home Shopping Unlocks Soon
        </h2>
        <p style={{ fontSize: '15px', color: '#6b7280', maxWidth: '400px', margin: '0 auto 24px' }}>
          Once your SmartEstimate™ is accepted, you'll be able to browse available homes here.
        </p>
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            padding: '12px 24px', background: '#2563EB', color: '#fff',
            border: 'none', borderRadius: '8px', cursor: 'pointer',
            fontWeight: '600', fontSize: '14px',
          }}
        >
          Back to Dashboard
        </button>
      </div>
    </AppShell>
  );
}

// Single source of truth for the "locked" statuses. Both Homes.js
// and HomeDetail.js import from here so the gate fires consistently
// (one page can never decide a stage is unlocked while the other
// shows the lock screen).
export const HOMES_LOCKED_STATUSES = [
  'new',
  'submitted',
  'applied',
  'docs_needed',
  'pre_qualified',
];
